import React from 'react'
import Header from '../header/index'
import styles from './hero.module.css'
import { brandlogo } from '../../assets'

const Hero = ({ children, className }) => {
  return (
    <div className={styles.hero}>
      <div className={styles.herowrapper}>
        <Header
          brand={brandlogo}
          brandToggle={brandlogo}
          mobileBrand={brandlogo}
        />
        <div className={styles.herocontent}>
          <div className={`${styles.herocontentwrapper} ${className}`}>
            <div className={styles.innercontent}>{children}</div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default Hero
